import React, { useState } from 'react';
import { FormDataConsumer, regex, required, email, Create, SimpleForm, TextInput, NumberInput, BooleanInput, useRedirect, SelectInput, ReferenceInput } from 'react-admin';
import DataProvider from '../../DataProvider.js'
import EditConfirmToolbar from '../../components/EditConfirmToolbar'
import ListSelect from '../../components/ListSelect'
import OrganizationTypeSelector from '../../components/Organization/OrganizationTypeSelector'

const OrganizationCreate = (props) => {

  const redirectTo = useRedirect();

  const [dTablets, setDTablets] = useState([])
  const [cLists, setCLists] = useState([])

  const [orgType, setOrgType] = useState("default")

  const uploadData = async (data) => {
    let _dtabs = [], _zones = [], _cLists = []
    
    for (let tablet of dTablets) _dtabs.push(tablet.id) 
    for (let list of cLists)  _cLists.push(list.id)

    data.is_channel_partner = orgType === 'cpartner'
    data.is_law_enforcement = orgType === 'law'

    try {
      if (data.is_channel_partner || data.is_law_enforcement) delete data.channel_partner_owner_id
    } catch (e) {
      console.log(e)
    }

    const cL = await DataProvider.create('organizations', { data: { ...data, zone_ids: _zones, dispatch_tablet_ids: _dtabs, contactlist_ids: _cLists }, })
    redirectTo('show', props.basePath, cL.data.id, cL)
  }


  return (
    <Create {...props}>
      <SimpleForm toolbar={<EditConfirmToolbar handlesave={uploadData} creating={true}  history={props.history}/>} redirect="show">
        <OrganizationTypeSelector orgType={orgType} setOrgType={setOrgType} />
        {orgType === 'default' ? <ReferenceInput perPage={1000000000000} fullWidth label="Channel Owner" source="channel_partner_owner_id" reference="organizations" filter={{ "channel": "channel" }}  >
          <SelectInput source="id" />
        </ReferenceInput> : null}
        <TextInput fullWidth label="Organization Name" source="name" validate={[required()]} />
        <BooleanInput label="Enable Mobile App" source="enable_mobile_app" />
        <BooleanInput label="Active" source="active" validate={[required()]} />
        <FormDataConsumer>
          {({ formData, ...rest }) => formData.enable_mobile_app &&
            <React.Fragment>
              <NumberInput fullWidth label="Latitude" source="lat" validate={[required()]} {...rest} />
              <NumberInput fullWidth label="Longitude" source="lng" validate={[required()]} {...rest} />
              <NumberInput fullWidth label="Range in Meters" source="mobile_trigger_range" validate={[required()]} {...rest} />
            </React.Fragment>
          }
        </FormDataConsumer>
        <BooleanInput label="Enable Anonymous Reporting" source="enable_anonymous_reporting" />
        <FormDataConsumer>
          {({ formData, ...rest }) => formData.enable_anonymous_reporting &&
            <TextInput fullWidth label="Anonymous Reporting Email" source="anonymous_reporting_email" validate={[email(), required()]} {...rest} />
          }
        </FormDataConsumer>
        <BooleanInput label="Enable MutuaLink" source="mutualink_enabled" />
        <FormDataConsumer>
          {({ formData, ...rest }) => formData.mutualink_enabled &&
            <TextInput fullWidth label="MutuaLink Customer ID" source="mutualink_customer_id" validate={[required()]} {...rest} />
          }
        </FormDataConsumer>
        <TextInput fullWidth label="Email Notification Header" source="email_notification_header" />
        <TextInput fullWidth label="Address Line 1" source="address_line_1" validate={[required()]} />
        <TextInput fullWidth label="Address Line 2" source="address_line_2" />
        <TextInput fullWidth label="City" source="address_city" validate={[required()]} />
        <SelectInput fullWidth label="State" source="address_state" validate={[required()]} choices={[{ id: 'AK', name: 'AK' }, { id: 'AL', name: 'AL' }, { id: 'AR', name: 'AR' }, { id: 'AZ', name: 'AZ' }, { id: 'CA', name: 'CA' }, { id: 'CO', name: 'CO' }, { id: 'CT', name: 'CT' }, { id: 'DC', name: 'DC' }, { id: 'DE', name: 'DE' }, { id: 'FL', name: 'FL' }, { id: 'GA', name: 'GA' }, { id: 'HI', name: 'HI' }, { id: 'IA', name: 'IA' }, { id: 'ID', name: 'ID' }, { id: 'IL', name: 'IL' }, { id: 'IN', name: 'IN' }, { id: 'KS', name: 'KS' }, { id: 'KY', name: 'KY' }, { id: 'LA', name: 'LA' }, { id: 'MA', name: 'MA' }, { id: 'MD', name: 'MD' }, { id: 'ME', name: 'ME' }, { id: 'MI', name: 'MI' }, { id: 'MN', name: 'MN' }, { id: 'MO', name: 'MO' }, { id: 'MS', name: 'MS' }, { id: 'MT', name: 'MT' }, { id: 'NC', name: 'NC' }, { id: 'ND', name: 'ND' }, { id: 'NE', name: 'NE' }, { id: 'NH', name: 'NH' }, { id: 'NJ', name: 'NJ' }, { id: 'NM', name: 'NM' }, { id: 'NV', name: 'NV' }, { id: 'NY', name: 'NY' }, { id: 'OH', name: 'OH' }, { id: 'OK', name: 'OK' }, { id: 'OR', name: 'OR' }, { id: 'PA', name: 'PA' }, { id: 'RI', name: 'RI' }, { id: 'SC', name: 'SC' }, { id: 'SD', name: 'SD' }, { id: 'TN', name: 'TN' }, { id: 'TX', name: 'TX' }, { id: 'UT', name: 'UT' }, { id: 'VA', name: 'VA' }, { id: 'VT', name: 'VT' }, { id: 'WA', name: 'WA' }, { id: 'WI', name: 'WI' }, { id: 'WV', name: 'WV' }, { id: 'WY', name: 'WY' }]} />
        <TextInput fullWidth label="Zip" source="address_zip" validate={[required()]} />

        <TextInput fullWidth label="Client Point Of Contact Name" source="client_poc_name" />
        <TextInput fullWidth label="Client Point Of Contact Phone Number" source="client_poc_phone" validate={[regex(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, "Must be a valid 10 digit US phone number.")]} />
        <TextInput fullWidth label="Client Point Of Contact Email Address" source="client_poc_email" validate={[email()]} />

        <TextInput fullWidth label="Dispatch Point Of Contact Name" source="dispatch_poc_name" />
        <TextInput fullWidth label="Dispatch Point Of Contact Phone Number" source="dispatch_poc_phone" validate={[regex(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, "Must be a valid 10 digit US phone number.")]} />
        <TextInput fullWidth label="Dispatch Point Of Contact Email Address" source="dispatch_poc_email" validate={[email()]} />

        <TextInput fullWidth label="Law Enforcement Point Of Contact Name" source="law_enforcement_poc_name" />
        <TextInput fullWidth label="Law Enforcement Point Of Contact Phone Number" source="law_enforcement_poc_phone" validate={[regex(/^(\+0?1\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, "Must be a valid 10 digit US phone number.")]} />
        <TextInput fullWidth label="Law Enforcement Point Of Contact Email Address" source="law_enforcement_poc_email" validate={[email()]} />


        <TextInput fullWidth label="Dispatch Console Alert Contact Number" source="alert_contact_phone_number" />

        <TextInput fullWidth label="Notes" source="notes" />
        <ListSelect
          {...props}
          headers={['Name', 'Organization Owner']}
          sources={['name', 'orgname']}
          filters={[{ source: 'name', placeholder: 'Add contactlist by name:' }]}
          filterorgid={false}
          target="contactlists"
          label="Contact Lists"
          selectedsource="contactlist_ids"
          updatestate={setCLists} />
        <ListSelect
          {...props}
          headers={['Email', 'Name']}
          sources={['email', 'displayName']}
          filters={[{ source: 'name', placeholder: 'Add tablet by name:' }]}
          filterorgid={false}
          target="dispatch-tablets"
          label="Dispatch Consoles"
          selectedsource="dispatch_tablet_ids"
          updatestate={setDTablets} />
      </SimpleForm>
    </Create>
  );
}
export default OrganizationCreate